export default "__VITE_ASSET__BRisnQYU__"